/**
 * プロフィール関連の設定値（ハードコード禁止ルールに従い定数化）。
 *
 * 参考: `.claude/rules/no-hardcode.md`, `.claude/rules/ymg-implementation-checklist.md`
 */

/** displayName の最大文字数（Hub 側制限は 100 だがゲーム UI の表示性を優先して短く抑える）。 */
export const MAX_DISPLAY_NAME_LENGTH = 16

/** アバターアイコングリッドの列数。 */
export const AVATAR_GRID_COLUMNS = 4

/** アバター未選択時のフォールバック絵文字（アセット未配信でも破綻しないため）。 */
export const DEFAULT_AVATAR_EMOJI = '🐾'

/**
 * 入力文字列から制御文字を除去する。
 *
 * U+0000-U+001F (C0 制御文字) と U+007F (DEL) を削除。
 * 表示名バリデーションの共通前処理として利用する。
 */
export function sanitizeDisplayName(raw: string): string {
  // eslint-disable-next-line no-control-regex
  return raw.replace(/[\u0000-\u001F\u007F]/g, '').trim()
}
